import type { Nullable } from "../types";

const PADDING = 3;

/**
 * This  function takes an atomic number string and returns it padded with leading zeros to ensure it has a consistent length.
 * @example 1.3.5 -> 001.003.005
 * @param atomicNumber
 * @returns
 */
export function getAtomicNumberString(atomicNumber: Nullable<string>) {
	if (!atomicNumber) {
		return "0".padStart(PADDING, "0");
	}
	if (typeof atomicNumber !== "string") {
		return "0".padStart(PADDING, "0");
	}
	const segments = atomicNumber.split(".");
	return segments.map((segment) => segment.padStart(PADDING, "0")).join(".");
}
